import React, { useEffect, useState } from 'react'
import { client } from '../index'
import gql from 'graphql-tag'

const FILE_URL = gql`
  query GetMediaUrl($fileKey: String!) {
    uri: mediaSignedUrl(key: $fileKey)
  }
`

const VideoPlayer = ({videoKey, handleMediaClick, useTranslate, type}) => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    const getVideoUrl = async (videoKey) => {
      client
        .query({
          query: FILE_URL,
          variables: {
            fileKey: videoKey,
          },
        }).then((result) => {

        setVideoUrl(result.data.uri)
      }).catch((e) => console.log(e))
    };

    if (type === "VIDEO") {
      getVideoUrl(videoKey);
    }

    if (type === "YOUTUBE") {
      setVideoUrl(videoKey);
    }
    //setVideoUrl("https://renesans-dev.sangre.eu/renesans/2f41a3cd-bac7-4111-b18a-1e522d350112/videos/dynamic-team-video.cbd0c3e4-f50c-4317-b5b7-b04b0fdfb1f9-6-.1d5a807b-a47d-43ba-85ee-0c9ccd0c5644.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=LZfOZwdXY5n8okK6XDCSK3hxycI145rG%2F20231005%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20231005T073628Z&X-Amz-Expires=7200&X-Amz-Signature=a00f98f325dd1d154d883eadc06efec1bd7b860b2d2da17e16f76834dd375bf3&X-Amz-SignedHeaders=host")
  }, [])

  return (
    <div className="about__files__video">
      <div className="video-container">
        {(type === "VIDEO" && videoUrl !== "") &&
          <video controls>
            <source src={videoUrl} type="video/mp4" />
          </video>
        }
        {(type === "YOUTUBE" && videoUrl !== "") &&
          <div className="video-iframe-container">
            <iframe
              width="560"
              height="315"
              src={videoUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen />
          </div>
        }
      </div>
      {type === "VIDEO" &&
        <p className="video-download">
          {useTranslate("landing.download_video_instruction")}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={() => handleMediaClick(videoKey)}
          >
            {useTranslate("landing.download_video")}
          </a>
        </p>
      }
    </div>
  )
}

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/components/video-player.js